import { each, equals2, flatMapL, go, mapL, takeL } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { TransformNS } from "../../../../Transform/TransformNS.js";
import { VONS } from "../../VO/VONS.js";
export class FreeStickerEditorSelectorController {
  constructor({ svg_el, transform_manipulator, getCTM }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._transform_manipulator = transform_manipulator;
    this._getCTM = getCTM;
    this._els = new Map();
    this._nw_point = CommonNS.UtilNS.createSVGPoint(svg_el)([0, 0]);
    this._ne_point = CommonNS.UtilNS.createSVGPoint(svg_el)([0, 0]);
    this._se_point = CommonNS.UtilNS.createSVGPoint(svg_el)([0, 0]);
    this._sw_point = CommonNS.UtilNS.createSVGPoint(svg_el)([0, 0]);
    this._matrix = svg_el.createSVGMatrix();
    this._is_show = false;
    this._mode = "DEFAULT";
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    const {
      nw_point,
      ne_point,
      se_point,
      sw_point,
      n_point,
      e_point,
      s_point,
      w_point,
    } = this._calculatePoints({
      nw_point: this._nw_point,
      ne_point: this._ne_point,
      se_point: this._se_point,
      sw_point: this._sw_point,
      matrix: this._matrix,
    });
    observer({
      is_show: this._is_show,
      mode: this._mode,
      scale_type: "SAME_RATIO",
      nw_point: {
        x: nw_point.x,
        y: nw_point.y,
      },
      ne_point: {
        x: ne_point.x,
        y: ne_point.y,
      },
      se_point: {
        x: se_point.x,
        y: se_point.y,
      },
      sw_point: {
        x: sw_point.x,
        y: sw_point.y,
      },
      n_point: {
        x: n_point.x,
        y: n_point.y,
      },
      e_point: {
        x: e_point.x,
        y: e_point.y,
      },
      s_point: {
        x: s_point.x,
        y: s_point.y,
      },
      w_point: {
        x: w_point.x,
        y: w_point.y,
      },
    });
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  transform(matrix) {
    this._matrix = matrix;
    const {
      nw_point,
      ne_point,
      se_point,
      sw_point,
      n_point,
      e_point,
      s_point,
      w_point,
    } = this._calculatePoints({
      nw_point: this._nw_point,
      ne_point: this._ne_point,
      se_point: this._se_point,
      sw_point: this._sw_point,
      matrix: this._matrix,
    });
    this._notify({
      is_show: this._is_show,
      mode: this._mode,
      scale_type: "SAME_RATIO",
      nw_point: {
        x: nw_point.x,
        y: nw_point.y,
      },
      ne_point: {
        x: ne_point.x,
        y: ne_point.y,
      },
      se_point: {
        x: se_point.x,
        y: se_point.y,
      },
      sw_point: {
        x: sw_point.x,
        y: sw_point.y,
      },
      n_point: {
        x: n_point.x,
        y: n_point.y,
      },
      e_point: {
        x: e_point.x,
        y: e_point.y,
      },
      s_point: {
        x: s_point.x,
        y: s_point.y,
      },
      w_point: {
        x: w_point.x,
        y: w_point.y,
      },
    });
  }
  syncWith(els) {
    if (els.size <= 0) {
      this._els = new Map();
      this._is_show = false;
      this._mode = "DEFAULT";
      this._nw_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([0, 0]);
      this._ne_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([0, 0]);
      this._se_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([0, 0]);
      this._sw_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([0, 0]);
      this._matrix = this._svg_el.createSVGMatrix();
      const {
        nw_point,
        ne_point,
        se_point,
        sw_point,
        n_point,
        e_point,
        s_point,
        w_point,
      } = this._calculatePoints({
        nw_point: this._nw_point,
        ne_point: this._ne_point,
        se_point: this._se_point,
        sw_point: this._sw_point,
        matrix: this._matrix,
      });
      this._notify({
        is_show: this._is_show,
        mode: this._mode,
        scale_type: "SAME_RATIO",
        nw_point: {
          x: nw_point.x,
          y: nw_point.y,
        },
        ne_point: {
          x: ne_point.x,
          y: ne_point.y,
        },
        se_point: {
          x: se_point.x,
          y: se_point.y,
        },
        sw_point: {
          x: sw_point.x,
          y: sw_point.y,
        },
        n_point: {
          x: n_point.x,
          y: n_point.y,
        },
        e_point: {
          x: e_point.x,
          y: e_point.y,
        },
        s_point: {
          x: s_point.x,
          y: s_point.y,
        },
        w_point: {
          x: w_point.x,
          y: w_point.y,
        },
      });
      return;
    }
    if (equals2(els.size)(1)) {
      each(({ id, wrapper_el, cutting_line_clip_path_el }) => {
        const bbox = cutting_line_clip_path_el.getBBox();
        const el_ctm = wrapper_el.getCTM();
        if (el_ctm == null) {
          throw new Error(`엘리먼트의 CTM 을 구할 수 없습니다.`);
        }
        const fixed_transform_matrix =
          this._transform_manipulator.getFixedTransform(wrapper_el)?.matrix ??
          CommonNS.UtilNS.getConsolidatedTransformMatrix(wrapper_el) ??
          this._svg_el.createSVGMatrix();
        const [_nw_point, _ne_point, _se_point, _sw_point] = go(
          [
            [bbox.x, bbox.y],
            // nw
            [bbox.x + bbox.width, bbox.y],
            // ne
            [bbox.x + bbox.width, bbox.y + bbox.height],
            // se
            [bbox.x, bbox.y + bbox.height], // sw
          ],
          mapL(CommonNS.UtilNS.createSVGPoint(this._svg_el)),
          mapL((point) => point.matrixTransform(fixed_transform_matrix)),
          CommonNS.UtilNS.calculateMinMaxXY,
          ({ min_x, min_y, max_x, max_y }) => [
            [min_x, min_y],
            [max_x, min_y],
            [max_x, max_y],
            [min_x, max_y],
          ],
          mapL(CommonNS.UtilNS.createSVGPoint(this._svg_el)),
          mapL((point) =>
            point.matrixTransform(
              el_ctm.multiply(fixed_transform_matrix.inverse())
            )
          )
        );
        this._els = new Map([
          [
            id,
            {
              id,
              wrapper_el,
              cutting_line_clip_path_el,
            },
          ],
        ]);
        this._is_show = true;
        this._nw_point = _nw_point;
        this._ne_point = _ne_point;
        this._se_point = _se_point;
        this._sw_point = _sw_point;
        this._matrix = this._svg_el.createSVGMatrix();
        const {
          nw_point,
          ne_point,
          se_point,
          sw_point,
          n_point,
          e_point,
          s_point,
          w_point,
        } = this._calculatePoints({
          nw_point: this._nw_point,
          ne_point: this._ne_point,
          se_point: this._se_point,
          sw_point: this._sw_point,
          matrix: this._matrix,
        });
        this._notify({
          is_show: this._is_show,
          mode: this._mode,
          scale_type: "SAME_RATIO",
          nw_point: {
            x: nw_point.x,
            y: nw_point.y,
          },
          ne_point: {
            x: ne_point.x,
            y: ne_point.y,
          },
          se_point: {
            x: se_point.x,
            y: se_point.y,
          },
          sw_point: {
            x: sw_point.x,
            y: sw_point.y,
          },
          n_point: {
            x: n_point.x,
            y: n_point.y,
          },
          e_point: {
            x: e_point.x,
            y: e_point.y,
          },
          s_point: {
            x: s_point.x,
            y: s_point.y,
          },
          w_point: {
            x: w_point.x,
            y: w_point.y,
          },
        });
      })(takeL(1)(els.values()));
      return;
    }
    const [_nw_point, _ne_point, _se_point, _sw_point] = go(
      els.values(),
      flatMapL(({ wrapper_el, cutting_line_clip_path_el }) => {
        const bbox = cutting_line_clip_path_el.getBBox();
        const el_ctm = wrapper_el.getCTM();
        if (el_ctm == null) {
          throw new Error(`엘리먼트의 CTM 을 구할 수 없습니다.`);
        }
        return go(
          [
            [bbox.x, bbox.y],
            [bbox.x + bbox.width, bbox.y],
            [bbox.x + bbox.width, bbox.y + bbox.height],
            [bbox.x, bbox.y + bbox.height],
          ],
          mapL(CommonNS.UtilNS.createSVGPoint(this._svg_el)),
          mapL((point) => point.matrixTransform(el_ctm))
        );
      }),
      CommonNS.UtilNS.calculateMinMaxXY,
      ({ min_x, min_y, max_x, max_y }) => [
        [min_x, min_y],
        [max_x, min_y],
        [max_x, max_y],
        [min_x, max_y],
      ],
      mapL(CommonNS.UtilNS.createSVGPoint(this._svg_el))
    );
    this._els = els;
    this._is_show = true;
    this._mode = "ONLY_TRANSLATE";
    this._nw_point = _nw_point;
    this._ne_point = _ne_point;
    this._se_point = _se_point;
    this._sw_point = _sw_point;
    this._matrix = this._svg_el.createSVGMatrix();
    const {
      nw_point,
      ne_point,
      se_point,
      sw_point,
      n_point,
      e_point,
      s_point,
      w_point,
    } = this._calculatePoints({
      nw_point: this._nw_point,
      ne_point: this._ne_point,
      se_point: this._se_point,
      sw_point: this._sw_point,
      matrix: this._matrix,
    });
    this._notify({
      is_show: this._is_show,
      mode: this._mode,
      scale_type: "SAME_RATIO",
      nw_point: {
        x: nw_point.x,
        y: nw_point.y,
      },
      ne_point: {
        x: ne_point.x,
        y: ne_point.y,
      },
      se_point: {
        x: se_point.x,
        y: se_point.y,
      },
      sw_point: {
        x: sw_point.x,
        y: sw_point.y,
      },
      n_point: {
        x: n_point.x,
        y: n_point.y,
      },
      e_point: {
        x: e_point.x,
        y: e_point.y,
      },
      s_point: {
        x: s_point.x,
        y: s_point.y,
      },
      w_point: {
        x: w_point.x,
        y: w_point.y,
      },
    });
  }
  setMode(mode) {
    this._mode = mode;
    const {
      nw_point,
      ne_point,
      se_point,
      sw_point,
      n_point,
      e_point,
      s_point,
      w_point,
    } = this._calculatePoints({
      nw_point: this._nw_point,
      ne_point: this._ne_point,
      se_point: this._se_point,
      sw_point: this._sw_point,
      matrix: this._matrix,
    });
    this._notify({
      is_show: this._is_show,
      mode: this._mode,
      scale_type: "SAME_RATIO",
      nw_point: {
        x: nw_point.x,
        y: nw_point.y,
      },
      ne_point: {
        x: ne_point.x,
        y: ne_point.y,
      },
      se_point: {
        x: se_point.x,
        y: se_point.y,
      },
      sw_point: {
        x: sw_point.x,
        y: sw_point.y,
      },
      n_point: {
        x: n_point.x,
        y: n_point.y,
      },
      e_point: {
        x: e_point.x,
        y: e_point.y,
      },
      s_point: {
        x: s_point.x,
        y: s_point.y,
      },
      w_point: {
        x: w_point.x,
        y: w_point.y,
      },
    });
  }
  _notify(selector_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(selector_vo));
    }
  }
  _calculatePoints({
    nw_point: _nw_point,
    ne_point: _ne_point,
    se_point: _se_point,
    sw_point: _sw_point,
    matrix: _matrix,
  }) {
    const ctm = this._getCTM();
    const matrix = ctm.inverse().multiply(_matrix).multiply(ctm);
    const [nw_point, ne_point, se_point, sw_point] = mapL((point) =>
      point.matrixTransform(matrix)
    )([_nw_point, _ne_point, _se_point, _sw_point]);
    const [n_point, e_point, s_point, w_point] = mapL(
      ([{ x: x1, y: y1 }, { x: x2, y: y2 }]) =>
        CommonNS.UtilNS.createSVGPoint(this._svg_el)([
          (x1 + x2) / 2,
          (y1 + y2) / 2,
        ])
    )([
      [nw_point, ne_point],
      // n
      [ne_point, se_point],
      // e
      [se_point, sw_point],
      // s
      [sw_point, nw_point], // w
    ]);

    return {
      nw_point,
      ne_point,
      se_point,
      sw_point,
      n_point,
      e_point,
      s_point,
      w_point,
    };
  }
}
